        window.kubeeLoaded = false;
        function loadJS() {
           var KB_URL = localStorage.getItem('kubee_url');
           var KB_TENANT = localStorage.getItem('kubee_tenant');
           var KB_W_I = localStorage.getItem('kubee_w_i');
           function loadScript(url,w_i,tenant) {
              var script = document.createElement("script");
              script.src = url;
              script.async = true;
    
              if (script.readyState) {
                 script.onreadystatechange = function() {
                       if (script.readyState === "loaded" || script.readyState === "complete") {
                          script.onreadystatechange = null;
                          kubee.init(w_i,tenant);
                          console.log("kubee.init called");
                          window.kubeeLoaded = true;
                          window.dispatchEvent(new Event('kubeeReady'));
                          localStorage.setItem("kubee_url", url);
                          localStorage.setItem("kubee_w_i", w_i);
                          localStorage.setItem("kubee_tenant", tenant);
                       }
                 };
              } else {
                 script.onload = function() {
                       kubee.init(w_i,tenant);
                       console.log("kubee.init called");
                       window.kubeeLoaded = true;
                       window.dispatchEvent(new Event('kubeeReady'));
                       localStorage.setItem("kubee_url", url);
                       localStorage.setItem("kubee_w_i", w_i);
                       localStorage.setItem("kubee_tenant", tenant);
                 };
              }
              document.head.appendChild(script);
           }
    
           if (!KB_URL || KB_URL === "undefined" || KB_URL === "null" || KB_URL.length <= 0 || !KB_TENANT || KB_TENANT === "undefined" || KB_TENANT === "null" || KB_TENANT.length <= 0  || !KB_W_I || KB_W_I === "undefined" || KB_W_I === "null" || KB_W_I.length <= 0  ) {
              const url = 'https://api-saas.kubeedevelopment.com/api/v1/kubeejsload/PZA-2217-0297';
              var requestOptions = { method: "GET", headers: { Accept: "application/json", "X-Tenant": "DEEP864320"  } };
    
              fetch(url, requestOptions)
                    .then(response => response.json())
                    .then(data => loadScript(data.data,"PZA-2217-0297","DEEP864320"))
                    .catch(error => console.error("Error:", error));
           } else {
              loadScript(KB_URL,KB_W_I,KB_TENANT);
           }
        }
    
        loadJS();